var DEFAULT_INITIAL_PATH_STORAGE_KEY = "guru-initial-path";
/**
 * Get current page path and search.
 * @returns {string} path with query params/search
 */
function getCurrentPathWithSearch() {
    return window.location.pathname + window.location.search;
}
/**
 * Store initial path to storage when AndroidHandler is available.
 * Put this function on pages/_app.tsx in Next.js
 * or Layout component in other framework.
 * @param {string} customKey custom storage key
 */
function storeAppInitialPath(customKey) {
    var pathToStore = window.location.pathname;
    var key = customKey !== null && customKey !== void 0 ? customKey : DEFAULT_INITIAL_PATH_STORAGE_KEY;
    var currentPath = window.sessionStorage.getItem(key);
    if (!currentPath && window.AndroidHandler) {
        window.sessionStorage.setItem(key, pathToStore);
    }
}
/**
 * Back to app from webview using jsbridge AndroidHandler.
 * @param {function} backFn fallback back function for non-webview
 * @param {string} customKey custom storage key
 *
 * @example
 * ```typescript
 * backToApp(() => window.history.back())
 * ```
 */
function backToApp(backFn, customKey) {
    var key = customKey !== null && customKey !== void 0 ? customKey : DEFAULT_INITIAL_PATH_STORAGE_KEY;
    var initialPath = window.sessionStorage.getItem(key);
    var currentPath = window.location.pathname;
    if (initialPath === currentPath && window.AndroidHandler) {
        window.sessionStorage.removeItem(key);
        window.AndroidHandler.backToApp();
    }
    else {
        backFn();
    }
}

export { DEFAULT_INITIAL_PATH_STORAGE_KEY, backToApp, getCurrentPathWithSearch, storeAppInitialPath };
